<template>
  <div class="alert-system">
    <!-- Alert Notifications -->
    <TransitionGroup name="alert" tag="div" class="alert-container">
      <div 
        v-for="(alert, index) in alerts" 
        :key="alert.id" 
        class="snackbar-wrapper"
      >
        <div 
          class="custom-snackbar"
          :class="alert.color"
        >
          {{ alert.message }}
          <div v-if="alert.timeout > 0" class="actions">
            <span class="countdown">{{ alert.countdown }}s</span>
            <v-btn icon="mdi-close" variant="text" @click="dismiss(alert.id)"></v-btn>
          </div>
        </div>
      </div>
    </TransitionGroup>

    <!-- Dialog System -->
    <v-dialog
      v-for="dialog in dialogs"
      :key="dialog.id"
      v-model="dialog.show"
      max-width="500"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5 pa-4">
          {{ dialog.title }}
        </v-card-title>

        <v-card-text class="pa-4">
          {{ dialog.description }}
        </v-card-text>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn
            v-for="button in dialog.buttons"
            :key="button.value"
            :color="button.color"
            :variant="button.variant || 'elevated'"
            @click="dialog.handleClick(button.value)"
            class="mx-1"
          >
            {{ button.text }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup>
import { useAlertStore } from '@/stores/alert'
import { storeToRefs } from 'pinia'

const alertStore = useAlertStore()
const { alerts, dialogs } = storeToRefs(alertStore)
const { dismiss } = alertStore
</script>

<style scoped>
.alert-system {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  width: 100%;
  max-width: 600px;
  pointer-events: none;
}

.alert-container {
  display: flex;
  flex-direction: column-reverse;
  gap: 8px;
}

.snackbar-wrapper {
  pointer-events: auto;
  padding: 0 16px;
}

.custom-snackbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 8px 10px 26px;
  border-radius: 8px;
  background: #333;
  color: white;
  box-shadow: 0 3px 5px -1px rgba(0,0,0,.2),0 6px 10px 0 rgba(0,0,0,.14),0 1px 18px 0 rgba(0,0,0,.12);
}

.custom-snackbar.success {
  background: #4caf50;
}

.custom-snackbar.error {
  background: #ff5252;
}

.custom-snackbar.info {
  background: #2196f3;
}

.custom-snackbar.warning {
  background: #fb8c00;
}

.actions {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-right: -4px;
}

.countdown {
  font-size: 0.9em;
  opacity: 0.8;
}

/* Transition animations */
.alert-enter-active,
.alert-leave-active {
  transition: all 0.3s ease;
}

.alert-enter-from {
  opacity: 0;
  transform: translateY(30px);
}

.alert-leave-to {
  opacity: 0;
  transform: translateX(100%);
}

.alert-move {
  transition: transform 0.3s ease;
}
</style>